import {AuthConfig,OAuthModuleConfig} from 'angular-oauth2-oidc';

import { environment,authConfigEnv } from './../../environments/environment.dev';

export const authConfig =  authConfigEnv;

// export const authConfig: AuthConfig = {
//    loginUrl: 'https://logindev.compound-connect.com/connect/authorize',
//    tokenEndpoint: 'https://logindev.compound-connect.com/connect/token',
//    logoutUrl: 'https://logindev.compound-connect.com/connect/endsession',
//    redirectUri: `${origin}`,
//    clientId: 'econsole_test_code',
//    scope: 'openid profile userapi offline_access',
//    responseType: 'code',
//    dummyClientSecret: 'ptc$123Secur1ty',
//    requestAccessToken: true,
//    clearHashAfterLogin: true,
//    showDebugInformation: true,
//    requireHttps: false,
//    strictDiscoveryDocumentValidation: false,
//    skipIssuerCheck: true,
//    timeoutFactor: 0.25,
//    useSilentRefresh: false,
// };
export const authModuleConfig: OAuthModuleConfig = {
    // Inject "Authorization: Bearer ..." header for these APIs:
    resourceServer: {
      allowedUrls: ['http://localhost:4200','https://econsole.z19.web.core.windows.net','http://localhost/ptc-DemoDev/', 'https://econsole.pipelinetesting.com/'],
      sendAccessToken: true,
    },
  };
 